import { render, staticRenderFns } from "./sameAccidents.vue?vue&type=template&id=e2852c14"
import script from "./sameAccidents.vue?vue&type=script&lang=js"
export * from "./sameAccidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2852c14')) {
      api.createRecord('e2852c14', component.options)
    } else {
      api.reload('e2852c14', component.options)
    }
    module.hot.accept("./sameAccidents.vue?vue&type=template&id=e2852c14", function () {
      api.rerender('e2852c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/same/sameAccidents.vue"
export default component.exports